import { PFLEGEFACHKRAFT_ROLE_GROUP } from '@pflegia/types/api/job-title/job-titles.enum';

export interface PflegefachkraftRoleGroup {
  slug: string;
  label: string;
  jobTitleIds: string[];
}

export const isPflegefachkraftSlug = (slug: string): boolean => slug === PFLEGEFACHKRAFT_ROLE_GROUP.slug;

export const isPflegefachkraftRoleGroupSelected = (
  positionIds: string[],
  pflegefachkraftRoleGroup?: Pick<PflegefachkraftRoleGroup, 'jobTitleIds'>,
): boolean =>
  Boolean(pflegefachkraftRoleGroup) &&
  positionIds.length === pflegefachkraftRoleGroup?.jobTitleIds.length &&
  pflegefachkraftRoleGroup.jobTitleIds.every(id => positionIds.includes(id));

export const isPflegefachkraftRoleGroupActive = (
  positionIds: string[],
  pflegefachkraftRoleGroup: Pick<PflegefachkraftRoleGroup, 'jobTitleIds'> | undefined,
  isRouteFallback: boolean,
): boolean =>
  Boolean(pflegefachkraftRoleGroup) &&
  ((isRouteFallback && positionIds.length === 0) || isPflegefachkraftRoleGroupSelected(positionIds, pflegefachkraftRoleGroup));
